var map = {
	"./2022/1_1.JPG": 8581,
	"./2022/1_2.JPG": 1833,
	"./2022/1_3.JPG": 7137,
	"./2022/2_1.JPG": 6799,
	"./2022/2_2.JPG": 3464,
	"./2022/2_3.JPG": 7553,
	"./2022/3_1.JPG": 6522,
	"./2022/3_2.JPG": 9345,
	"./2022/3_3.JPG": 7303,
	"./2022/4_1.JPG": 8367,
	"./2022/4_2.JPG": 7780,
	"./2022/4_3.JPG": 7680,
	"./2022/5_1.JPG": 6725,
	"./2022/5_2.JPG": 3550,
	"./2022/5_3.JPG": 1958,
	"./2022/6_1.JPG": 3456,
	"./2022/6_2.JPG": 8930,
	"./2022/6_3.JPG": 9291,
	"./2022/championship.JPG": 845,
	"./2023/1_1.JPG": 5716,
	"./2023/1_2.JPG": 3720,
	"./2023/1_3.JPG": 3849,
	"./2023/1_4.JPG": 7321,
	"./2023/2_1.JPG": 6111,
	"./2023/2_2.JPG": 5963,
	"./2023/2_3.JPG": 144,
	"./2023/2_4.JPG": 3008,
	"./2023/3_1.JPG": 6103,
	"./2023/3_2.JPG": 7790,
	"./2023/3_3.JPG": 1367,
	"./2023/3_4.JPG": 5755,
	"./2023/4_1.JPG": 8216,
	"./2023/4_2.JPG": 1391,
	"./2023/4_3.JPG": 9578,
	"./2023/4_4.JPG": 4758,
	"./2023/5_1.JPG": 7649,
	"./2023/5_2.JPG": 5202,
	"./2023/5_3.JPG": 9780,
	"./2023/5_4.JPG": 5502,
	"./2023/6_1.JPG": 2768,
	"./2023/6_2.JPG": 3194,
	"./2023/6_3.JPG": 8257,
	"./2023/championship.JPG": 7336,
	"./2024/1_1.JPG": 2824,
	"./2024/1_2.JPG": 4756,
	"./2024/1_3.JPG": 8559,
	"./2024/1_4.JPG": 6507,
	"./2024/1_5.JPG": 5729,
	"./2024/2_1.JPG": 3367,
	"./2024/2_2.JPG": 8012,
	"./2024/2_3.JPG": 6950,
	"./2024/2_4.JPG": 9336,
	"./2024/2_5.JPG": 601,
	"./2024/3_1.JPG": 1540,
	"./2024/3_2.JPG": 4359,
	"./2024/3_3.JPG": 9764,
	"./2024/3_4.JPG": 9596,
	"./2024/3_5.JPG": 7515,
	"./2024/4_1.JPG": 3370,
	"./2024/4_2.JPG": 9257,
	"./2024/4_3.JPG": 3022,
	"./2024/4_4.JPG": 7703,
	"./2024/4_5.JPG": 3986,
	"./2024/5_1.JPG": 8902,
	"./2024/5_2.JPG": 986,
	"./2024/5_3.JPG": 2456,
	"./2024/5_4.JPG": 7733,
	"./2024/5_5.JPG": 7204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2807;